import {
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    useDisclosure,
    ModalCloseButton,
    ModalHeader,
} from "@chakra-ui/react";
import { css, keyframes } from '@emotion/react';

import ResponseForm from "./responseForm";
import { useEffect } from "react";

const borderAnimation = keyframes`
  0% {
    border-color: transparent;
    transform: scale(1);
  }
  50% {
    border-color: rgba(230, 0, 0, 0.5);
    transform: scale(1.45);
  }
  100% {
    border-color: transparent;
    transform: scale(1);
  }
`;

function RsvpSmall({ firstName, lastName, allowedAddtlGuest, inviteCode, inviteId }) {
    const { isOpen, onOpen, onClose } = useDisclosure()

    useEffect(() => {
        onOpen();
    }, [])
    return (
        <div>
            <Button
                position="fixed"
                bottom="20px"
                right="30px"
                zIndex="overlay"
                colorScheme="teal"
                borderRadius="full"
                boxShadow="2xl"
                border="8px solid transparent"
                css={css`
                    animation: ${borderAnimation} 1s infinite;
                    &:hover {
                        border-color: pink.500;
                    }
                    `}
                onClick={onOpen}>Click me to RSVP</Button>
            <Modal
                blockScrollOnMount={true}
                isOpen={isOpen}
                padding={1}
                onClose={onClose}>

                <ModalOverlay />
                <ModalContent
                    padding={1}
                    maxW='90%' >
                    <ModalHeader>
                        <ModalCloseButton />

                    </ModalHeader>
                    <ResponseForm
                        firstName={firstName}
                        lastName={lastName}
                        allowedAddtlGuest={allowedAddtlGuest}
                        inviteCode={inviteCode}
                        inviteId={inviteId}
                        onClose={onClose} />
                </ModalContent>
            </Modal>
        </div >
    )
}
export default RsvpSmall;